export enum EntityStoreKey {
  account = 'account',
  deletionRequests = 'deletionRequests',
  reportConfiguration = 'reportConfiguration',
  users = 'users',
  guest = 'guest',
  userPreferences = 'userPreferences',
}
